import { locales as baseLocales } from "../locales/locales.js";

export const sharerLocales = {
	sms: {
		en: "SMS",
		de: "SMS",
		fr: "SMS",
		ca: "SMS",
		es: "SMS",
		nl: "SMS",
		da: "SMS",
		"pt-BR": "SMS",
		ru: "SMS",
		it: "SMS",
	},
	messenger: {
		en: "Messenger",
		de: "Messenger",
		fr: "Messenger",
		ca: "Messenger",
		es: "Messenger",
		nl: "Messenger",
		da: "Messenger",
		"pt-BR": "Messenger",
		ru: "Messenger",
		it: "Messenger",
	},
	whatsapp: {
		en: "WhatsApp",
		de: "WhatsApp",
		fr: "WhatsApp",
		ca: "WhatsApp",
		es: "WhatsApp",
		nl: "WhatsApp",
		da: "WhatsApp",
		"pt-BR": "WhatsApp",
		ru: "WhatsApp",
		it: "WhatsApp",
	},
	twitter: {
		en: "Twitter",
		de: "Twitter",
		fr: "Twitter",
		ca: "Twitter",
		es: "Twitter",
		nl: "Twitter",
		da: "Twitter",
		"pt-BR": "Twitter",
		ru: "Twitter",
		it: "Twitter",
	},
	linkedin: {
		en: "Linkedin",
		de: "Linkedin",
		fr: "Linkedin",
		ca: "Linkedin",
		es: "Linkedin",
		nl: "Linkedin",
		da: "Linkedin",
		"pt-BR": "Linkedin",
		ru: "Linkedin",
		it: "Linkedin",
	},
	telegram: {
		en: "Telegram",
		de: "Telegram",
		fr: "Telegram",
		ca: "Telegram",
		es: "Telegram",
		nl: "Telegram",
		da: "Telegram",
		"pt-BR": "Telegram",
		ru: "Telegram",
		it: "Telegram",
	},
	facebook: {
		en: "Facebook",
		de: "Facebook",
		fr: "Facebook",
		ca: "Facebook",
		es: "Facebook",
		nl: "Facebook",
		da: "Facebook",
		"pt-BR": "Facebook",
		ru: "Facebook",
		it: "Facebook",
	},
	pinterest: {
		en: "Pinterest",
		de: "Pinterest",
		fr: "Pinterest",
		ca: "Pinterest",
		es: "Pinterest",
		nl: "Pinterest",
		da: "Pinterest",
		"pt-BR": "Pinterest",
		ru: "Pinterest",
		it: "Pinterest",
	},
	shareTitle: {
		en: "Share",
		de: "Teilen",
		fr: "Partager",
		ca: "Share",
		es: "Compartir",
		nl: "Delen",
		da: "Del",
		"pt-BR": "Compartilhar",
		ru: "Поделиться",
		it: "Share",
	},
	cancel: {
		en: "Cancel",
		de: "Abbrechen",
		fr: "Annuler",
		ca: "Cancel",
		es: "Cancelar",
		nl: "Annuleren",
		da: "Luk",
		"pt-BR": "Cancelar",
		ru: "Отмена",
		it: "Cancel",
	},
	copy: {
		en: "Copy",
		de: "Kopieren",
		fr: "Copier",
		ca: "Copy",
		es: "Copiar",
		nl: "Kopiëren",
		da: "Kopiér",
		"pt-BR": "Copiar",
		ru: "Скопировать",
		it: "Copy",
	},
	print: {
		en: "Print",
		de: "Drucken",
		fr: "Imprimer",
		ca: "Print",
		es: "Imprimir",
		nl: "Printen",
		da: "Udskriv",
		"pt-BR": "Imprimir",
		ru: "Печать",
		it: "",
	},
	email: {
		en: "E-mail",
		de: "E-mail",
		fr: "E-mail",
		ca: "E-mail",
		es: "Correo",
		nl: "E-mail",
		da: "E-mail",
		"pt-BR": "E-mail",
		ru: "Э-майл",
		it: "E-mail",
	},
	selectSms: {
		en: "Pick a contact",
		de: "Wählen Sie einen Kontakt aus",
		fr: "Veuillez choisir un contact",
		ca: "Pick a contact",
		es: "Seleccionar un contacto",
		nl: "Selecteer een contact",
		da: "Vælg en kontaktperson",
		"pt-BR": "Selecione um contato",
		ru: "Выбери контакт",
		it: "Pick a contact",
	},
};

let supportedLanguages = [
	"en",
	"cy",
	"it",
	"fr",
	"de",
	"es",
	"ca",
	"nl",
	"da",
	"pt-BR",
	"ru",
];

/** Checks if a language is supported */
export const localeAvailable = (locale) => {
	return supportedLanguages.indexOf(locale) >= 0;
};

export function availableLocales() {
	return supportedLanguages;
}

// Extend this to include _CassisLocales
// Also, let's forget about unit testing this for now
/* c8 ignore next 15 */
function createLocales() {
	return function (a, extraLocales) {
		const locales = Object.assign({}, extraLocales, a);
		if ("_CassisLocales" in window) {
			const extraLocales = window._CassisLocales;
			for (const extraLocale of extraLocales) {
				supportedLanguages = supportedLanguages.concat(extraLocale.lang);
				for (const key of Object.keys(a)) {
					locales[key] = Object.assign(a[key], extraLocale.locale[key]);
				}
			}
		}
		return locales;
	};
}

export const locales = createLocales()(baseLocales, sharerLocales);
